import axios from 'axios'
import store from '@/store'

export default {
  fetchNotEstimatedTasks (formData) {
    return new Promise((resolve, reject) => {
      axios.post('/api/issues/not_estimated', formData, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        store.dispatch('setNotEstimatedIssues', data)
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  }
}
